
<div class="container">
  <section>  
  <p class="text-center">
      <img src="/assets/images/no-user.png" alt="Angular Logo"><br>
  User is not configured in ERG System. Please reach out to Admin !
</p>
</section>
</div>
